import {useEffect, useRef, useState} from 'react'
import {message} from "antd";
import {
  SActionBtn,
  SLowcodeList, SMessage,
  STableActions,
} from 'shj-components'
import {getSeatAccountPage, seatAccountDel} from "@/services/crmTool.ts";
import {getSeatWorkerList} from "@/services/saleOpServices.ts";
import {apiData2Table} from "@/utils/data.ts";

import {AddOrEdit} from "./AddOrEdit";
import {config} from './config.tsx'
import {departmentSearchList} from "@/services/customerServices.ts";
import {isArray} from "lodash-es";

export default function Seating() {
  const listRef = useRef()
  const [open, setOpen] = useState(false)
  const [record, setRecord] = useState({})
  const [seatPerson, setSeatPerson] = useState([])

  useEffect(() => {
    getOptions()
  }, []);

  const getOptions = async () => {
    const seatPerson = await getSeatWorkerList();
    setSeatPerson(seatPerson)
  }

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      getSeatAccountPage({params: {pageId: current, pageSize}, data: {...query}}).then((res: any) => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }

  const onAdd = () => onEdit()
  const onEdit = (record = {}) => {
    setOpen(true)
    setRecord(record)
  }

  //  表格事件: 删除
  const onDel = id => {
    SMessage.confirm({
      onOk: () => {
        return seatAccountDel(id).then((res: any) => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  const extensions = {
    request: {fetchList},
    events: {onAdd},
    status: {
      selectedDisabled: ({selectedRowKeys}: any) => !selectedRowKeys.length,
      radioDisabled: ({selectedRowKeys}: any) => selectedRowKeys.length !== 1,
    },
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
            <STableActions>
              {record.brand === 'HELI' && <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>}
              {/*<SActionBtn onClick={() => onBind(record)}>绑定坐席</SActionBtn>*/}
              <SActionBtn danger onClick={() => onDel(record.id)}>删除</SActionBtn>
            </STableActions>
        )
      },
    },
  }
  return (<>
    <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
    <AddOrEdit open={open}
                        record={record}
                        seatPerson={seatPerson}
                        onReload={listRef.current?.reload}
                        setOpen={(open: boolean) => setOpen(open)}
    />
  </>)
}
